const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content liked by component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Suggestions} Suggestions the resource defined to manage Suggestions
 */
app.directive('contentLikedBy', [function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      users: '=',
      hasLiked: '=',
      totalLikes: '='
    },
    template: require('../../templates/directives/content-liked-by.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.additional = 0;
      self.show = false;

      self.setAdditional = function() {
        if (!$scope.users || !$scope.users.length) {
          return;
        }
        if (!$scope.totalLikes || typeof $scope.totalLikes !== 'number') {
          return;
        }
        if (!$scope.hasLiked && $scope.totalLikes < 7 || $scope.hasLiked && $scope.totalLikes < 8) {
          self.additional = 0;
          return;
        }
        self.additional = $scope.hasLiked ? $scope.totalLikes - 7 : $scope.totalLikes - 6;
      };

      $scope.$watch('hasLiked', function(newVal, oldVal) {
        if (!newVal || oldVal === newVal) {
          return;
        }
        self.setAdditional();
      });
      $scope.$watch('users', function(newVal, oldVal) {
        if (!newVal || oldVal === newVal) {
          return;
        }
        self.setAdditional();
      });
      $scope.$watch('totalLikes', function(newVal, oldVal) {
        if (!newVal || oldVal === newVal) {
          return;
        }
        self.setAdditional();
      });
      self.setAdditional();

    }],
    controllerAs: 'likedby'
  };
}]);

